var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav_item text_size_14 tw-flex tw-justify-center tw-items-center",class:{'active': _vm.isActive},on:{"click":_vm.onClick}},[_c('p',{staticClass:"nav_item_label"},[_vm._v(_vm._s(_vm.item.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }